import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DEFAULT_HOMEPAGE = '/my-assignments';

/**
 * Per-user homepage redirect (plan section 1.6).
 *
 * The `/` route renders this component; we read the user's
 * `default_landing_route` from auth context and `<Navigate>` there.
 * Falls back to `/my-assignments` when the user has no preference set
 * or when auth is still loading.
 */
const HomepageRedirect: React.FC = () => {
  const { user } = useAuth();
  const target = user?.default_landing_route || DEFAULT_HOMEPAGE;
  return <Navigate to={target} replace />;
};

export default HomepageRedirect;
